/**
 * Split Content Blocks — front-end behavior.
 */
export class SplitContentBlocksFront {
	/**
	 * @param {HTMLElement} element Root `.split-content-blocks` section.
	 */
	constructor( element ) {
		console.log( 'SplitContentBlocksFront', element );
	}
}
